import src from "IMAGE";
export default { src, width: 203, height: 158, blurWidth: 0, blurHeight: 0};
